'use client'

import { useEffect } from 'react'
import { initKaspi, isKaspiWebView } from '@/superapp/providers/kaspi/sdk/client'
import { analytics } from '@/tools/analytics'
import { initAuth } from '@/tools/auth'
import { injectAppVersion } from '@/tools/config'
import { InjectCookieScripts } from '@/tools/cookies-blocker/ui/InjectCookiesBlockerScripts'
import { initDeviceDetection } from '@/tools/device-detection'
import { glovoRum, initObservability } from '@/tools/o11y/client'
import { InjectAntiphishingScript } from '@/tools/security-antiphising/InjectAntiphisingScript'
import { SnackbarContainer } from '@/tools/ui'
import { InitPintxo } from '@/tools/ui/config/client'

interface Props {
  userId?: string
}

const initClient = async ({ userId }: Props) => {
  injectAppVersion()
  initAuth()
  await Promise.all([initDeviceDetection({ userId }), analytics.init()])
  if (isKaspiWebView()) {
    await initKaspi()
  }
}

export const InitClient = ({ userId }: Props) => {
  // eslint-disable-next-line o11y-guard/error-tracking
  useEffect(() => {
    initObservability()
    initClient({ userId }).catch((e) => glovoRum.addError(e, {}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <InjectCookieScripts />
      <SnackbarContainer />
      <InitPintxo />
      <InjectAntiphishingScript />
    </>
  )
}
